// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';

$w.onReady(function () {

    if (wixWindow.multilingual.currentLanguage ===  'en') {
        $w('#horizontalMenu2').hide();
       // $w('#horizontalMenu2').collapse();
      //  $w('#horizontalMenu1').expand();
        $w('#horizontalMenu1').show();
    } else { //'he'
        $w('#horizontalMenu1').hide();
       // $w('#horizontalMenu1').collapse();
      //  $w('#horizontalMenu2').expand();
        $w('#horizontalMenu2').show();
    }

});